import getTableOfContents from "../A4Pages/TableOfContents";
export default function insertTableOfContents(initialSections = []) {
    if (!initialSections) return;
    const sections = initialSections.slice();
    const start = sections.findIndex(({ id = "" })=>id.includes("toc"));
    if (start === -1) return sections;
    const tocSections = getTableOfContents(sections);
    tocSections.forEach((tocSection, index)=>{
        const existingIndex = sections.findIndex((section)=>section.id === tocSection.id);
        if (existingIndex !== -1) {
            // If TOC section exists, update its child key
            sections[existingIndex].child = tocSection.child;
        } else {
            // If TOC section doesn't exist, insert it at the appropriate index
            sections.splice(start + index, 0, tocSection);
        }
    });
    return sections;
}
